export {
  default as plus,
  ReactComponent as Plus,
} from '@assets/controls/plus.svg'    
